import { render, staticRenderFns } from "./TMapPointPicker.vue?vue&type=template&id=2059bd9c&scoped=true&"
import script from "./TMapPointPicker.vue?vue&type=script&lang=js&"
export * from "./TMapPointPicker.vue?vue&type=script&lang=js&"
import style0 from "./TMapPointPicker.vue?vue&type=style&index=0&id=2059bd9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059bd9c",
  null
  
)

export default component.exports